import Vue from 'vue';
import VueRouter from 'vue-router';
import AuthGuard from '@/misc/AuthGuard';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'entry_view',
            redirect: { name: 'library_view' },
            component: () => import(/* webpackChunkName: "EntryView" */ '../views/Entry.view.vue'),
            children: [
                {
                    path: '/code',
                    name: 'code_view',
                    component: () => import(/* webpackChunkName: "CodeView" */ '../views/Code.view.vue'),
                    beforeEnter: AuthGuard.checkForShowRoomMode
                },
                {
                    path: '/root',
                    name: 'root_view',
                    component: () => import(/* webpackChunkName: "RootView" */ '../views/Root.view.vue'),
                    children: [
                        {
                            path: '/library',
                            alias: '/',
                            name: 'library_view',
                            component: () => import(/* webpackChunkName: "LibraryView" */ '../views/Library.view.vue')
                        },
                        {
                            path: '/reader',
                            name: 'reader_view',
                            component: () => import(/* webpackChunkName: "ReaderView" */ '../views/Reader.view.vue'),
                            beforeEnter: AuthGuard.checkForShowRoomMode
                        }
                    ]
                }
            ]
        },
        {
            path: '*',
            redirect: { name: 'entry_view' }
        }
    ]
});

export default router;
